<ng-content select="[~left]"></ng-content>
<ng-content select="[~title]"></ng-content>
<ng-content select="[~right]"></ng-content>

<ng-container *ngIf="box$ | async as box">
	<div #backdrop moveToRoot class="floating-menu backdrop" [class.has-backdrop]="hasBackdrop"
		[style.z-index]="!hasBackdrop ? 101 : 100" (click)="close()">
		<div #wrapper class="wrapper border-box br-1h ov-h shadow-menu fl fl-dir-c fl-ai-fs fl-jc-fs"
			[class.h-100]="fullHeight" [class.bg-280]="!lightBg" [class.bg-180]="lightBg"
			[class.RIGHT]="$positionClasses().RIGHT" [ngClass]="{
				'position-at-top-of-target': box.positionAtTopOfTarget,
				'position-at-left-of-target': box.positionAtLeftOfTarget
			}" [ngStyle]="{
				'--__top.px': box.top,
				'--__bottom.px': box.bottom,
				'--__anchorHeight.px': box.anchorHeight,
				'--__left.px': box.left,
				'--__right.px': box.right,
				'--__anchorWidth.px': box.anchorWidth,
				'--__maxWidth.px': box.maxWidth,
				'--__maxHeight.px': box.maxHeight,
				'--__BASE_WIDTH.px': box.baseWidth,
				'--__BASE_MAX_HEIGHT': maxHeight,
				'min-width.px': box.minWidth,
				'z-index': !hasBackdrop ? 101 : 100
			}" (click)="$event.stopPropagation()">
			<div class="w-100 max-h-100 border-box ov-auto" [class.h-100]="fullHeight">
				<ng-content></ng-content>
			</div>

			<ng-content select="[~footer]"></ng-content>
		</div>
	</div>
</ng-container>